import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_INVOICE_CLIENT_ITEM_RESET   = 'POST_INVOICE_CLIENT_ITEM_RESET';
export const POST_INVOICE_CLIENT_ITEM_LOADING = 'POST_INVOICE_CLIENT_ITEM_LOADING';
export const POST_INVOICE_CLIENT_ITEM_SUCCESS = 'POST_INVOICE_CLIENT_ITEM_SUCCESS';
export const POST_INVOICE_CLIENT_ITEM_REJECT  = 'POST_INVOICE_CLIENT_ITEM_REJECT';

//* ACTIONS ------------------------------------------------
export const postInvoiceClientItemReset   = () => ({ type: POST_INVOICE_CLIENT_ITEM_RESET });
export const postInvoiceClientItemLoading = () => ({ type: POST_INVOICE_CLIENT_ITEM_LOADING });
export const postInvoiceClientItemSuccess = (payload) => ({ type: POST_INVOICE_CLIENT_ITEM_SUCCESS, payload });
export const postInvoiceClientItemReject  = (payload) => ({ type: POST_INVOICE_CLIENT_ITEM_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const postInvoiceClientItemRequest = async (body = {}, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data: body,
    }, getState);
    return request(`/Invoices/web/AddInvoicesLine`, options);
};
